var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promotion-modal"},[(_vm.showPromotion)?_c('ModalDynamicPromotion',{ref:"modal",attrs:{"seen-promotions-property":"new-hackstack-promotion-modal"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('HackstackPromotionComponent',{on:{"close":_vm.onClose}})]},proxy:true}],null,false,1211445406)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }